import { DEFAULTS } from "@/react/story/data";
import type { Content } from "@/react/story/types";
import TemplatingUtils from "@/react/story/utils/TemplatingUtils";

type Props = {
    content: Content;
}

export default function ContentImage(props: Props) {
    const image = props.content.config.image ?? null;
    if (null === image) {
        return null;
    }

    return (
        <img
            src={image.uri}
            alt=""
            style={{
                maxWidth: TemplatingUtils.percent(DEFAULTS.maxWidth),
                ...TemplatingUtils.style(props.content.config, [ "maxWidth", "borderRadius" ]),
            }}
        />
    );
}
